import { render, staticRenderFns } from "./SearchResultsCompanyScan.vue?vue&type=template&id=4faa7c9c&scoped=true&"
import script from "./SearchResultsCompanyScan.vue?vue&type=script&lang=js&"
export * from "./SearchResultsCompanyScan.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsCompanyScan.vue?vue&type=style&index=0&id=4faa7c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa7c9c",
  null
  
)

export default component.exports